/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const mutateTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const mutateTypeDefinitionReferenceViewPredicatesMax = 10;

export const mutateTypeDefinitionReferenceViewSearchTermsItemMax = 200;

export const mutateTypeDefinitionReferenceViewSearchTermsMax = 10;

export const MutateTypeDefinition = zod.object({
  conformance: zod
    .enum(['open', 'lax', 'strict'])
    .optional()
    .describe(
      'open enforces slots and allows extra bodies; strict additionally rejects extra bodies; lax admits slot violations and reports them in audit. Omission preserves the stored declaration; null cannot clear it.',
    ),
  description: zod.string().nullish(),
  enums: zod
    .array(
      zod.object({
        label: zod.string(),
        value: zod.string(),
      }),
    )
    .nullish()
    .describe(
      'Ordered ENUM choices as { value, label } pairs. Both are preserved; this contract does not collapse a label into its value.',
    ),
  file: zod
    .object({
      allowedFormats: zod
        .array(
          zod.enum([
            'pdf',
            'doc',
            'docx',
            'xls',
            'xlsx',
            'csv',
            'txt',
            'jpeg',
            'png',
            'webp',
            'gif',
            'heic',
            'md',
            'html',
            'mp3',
            'm4a',
            'wav',
            'mp4',
            'mov',
            'webm',
          ]),
        )
        .min(1)
        .optional(),
    })
    .nullish(),
  metadata: zod
    .record(zod.string(), zod.unknown())
    .nullish()
    .describe(
      'Arbitrary authored metadata. Its keys are content, not command fields, and are stored and returned unaltered.',
    ),
  reference: zod
    .object({
      carbonCopy: zod.boolean().optional(),
      creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
      edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
      typeLineageUuid: zod.uuid(),
      typeUuid: zod.uuid(),
      view: zod
        .object({
          predicates: zod
            .array(
              zod.object({
                op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                pathTypeUuids: zod
                  .array(zod.uuid())
                  .min(1)
                  .max(mutateTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax),
                value: zod.string().optional(),
                valueType: zod
                  .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                  .optional(),
              }),
            )
            .max(mutateTypeDefinitionReferenceViewPredicatesMax)
            .optional(),
          searchTerms: zod
            .array(zod.string().min(1).max(mutateTypeDefinitionReferenceViewSearchTermsItemMax))
            .max(mutateTypeDefinitionReferenceViewSearchTermsMax)
            .optional(),
        })
        .nullish(),
    })
    .nullish(),
  signature: zod.looseObject({}).nullish(),
});

export type MutateTypeDefinition = zod.input<typeof MutateTypeDefinition>;
export type MutateTypeDefinitionOutput = zod.output<typeof MutateTypeDefinition>;
